import React, { useEffect } from "react";
import { makeStyles } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import {connect} from "react-redux";
import WorkProcessTable from "./WorkProcessTable";
import {getRequestWorkInfo, getWorkProcessList} from "../../../store/actions";

const useStyles = makeStyles(() => ({
  root: {
    paddingLeft: 8,
    width: 774,
    "& .MuiFormLabel-root": {
      whiteSpace: "nowrap"
    },
    "& .MuiInputBase-input.Mui-disabled": {
      color: "#000"
    }
  },
  progress: {
    display: "flex",
    justifyContent: "center"
  },
  heading: {
    fontSize: 14,
    lineHeight: "18px",
    display: "flex",
    alignItems: "center",
    color: "#000000",
    margin: "8px 0"
  },
  block: {
    margin: "0 0 32px 0"
  }
}));

const RequestWorkSteps = ({
                            requestId,
                            getRequestWorkInfo,
                            requestWork,
                            getWorkProcessList,
                            processList
                          }) => {
  const classes = useStyles();

  useEffect(() => {
    if (requestId) {
      getWorkProcessList(requestId);
    }
  }, [requestId])

  return (
    <div className={classes.root}>
      <div className={classes.block}>
        <Typography className={classes.heading}>Обработка заявки</Typography>
        {processList &&
          <WorkProcessTable processList={processList}/>
        }
      </div>
    </div>
  );
};

const mapStateToProps = state => ({
  requestWork: state.studyRequests.requestWork,
  processList: state.studyRequests.processList
});

const mapDispatchToProps = dispatch => ({
  getRequestWorkInfo: id => dispatch(getRequestWorkInfo(id)),
  getWorkProcessList: id => dispatch(getWorkProcessList(id))
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(RequestWorkSteps);
